"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommunicationFont;
(function (CommunicationFont) {
    CommunicationFont["Arial"] = "Arial, Helvetica Neue, Helvetica, sans-serif";
    CommunicationFont["Calibri"] = "Calibri, Carlito, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif";
    CommunicationFont["Times New Roman"] = "Times New Roman, Times, serif";
})(CommunicationFont = exports.CommunicationFont || (exports.CommunicationFont = {}));
//# sourceMappingURL=CommunicationFont.js.map